import { useMatchStatusActions } from './useMatchStatusActions'
import { useMatchLinkingActions } from './useMatchLinkingActions'
import { useMatchTaxActions } from './useMatchTaxActions'
import { useMatchCommentActions } from './useMatchCommentActions'

// Re-export type aliases for backward compatibility
export type { MatchSetHoldRequest, MatchApproveRequest } from './useMatchStatusActions'
export type {
  MatchLinkRequest,
  MatchOptionsForInvoiceRequest,
  MatchOptionsForBolRequest,
} from './useMatchLinkingActions'

/**
 * Hook for managing match actions (approve, hold, link, etc.)
 * Refactored to compose focused hook modules
 */
export const useMatchActions = () => {
  const statusActions = useMatchStatusActions()
  const linkingActions = useMatchLinkingActions()
  const taxActions = useMatchTaxActions()
  const commentActions = useMatchCommentActions()

  // High-level action handlers for backward compatibility
  const matchActionHandlers = {
    approveMatch: async () => {
      throw new Error('Use the useApproveMatch hook directly in components')
    },
    holdMatch: async () => {
      throw new Error('Use the useSetMatchHold hook directly in components')
    },
    bulkApprove: async () => {
      throw new Error('Bulk approve not yet implemented')
    },
    bulkHold: async () => {
      throw new Error('Bulk hold not yet implemented')
    },
  }

  return {
    // Status actions (approve, hold)
    useUnapproveMatch: statusActions.useUnapproveMatch,
    useApproveMatch: statusActions.useApproveMatch,
    useSetMatchHold: statusActions.useSetMatchHold,

    // Linking actions (link, options)
    useLinkMatch: linkingActions.useLinkMatch,
    useMatchOptionsForInvoice: linkingActions.useMatchOptionsForInvoice,
    useMatchOptionsForBol: linkingActions.useMatchOptionsForBol,

    // Tax actions (recalculation, order management)
    useSetTaxTransactionOrder: taxActions.useSetTaxTransactionOrder,
    useRecalculateMatch: taxActions.useRecalculateMatch,
    extractOrderNumbers: taxActions.extractOrderNumbers,
    canRecalculateTaxes: taxActions.canRecalculateTaxes,
    mapOverviewRowsToBolTaxTransactions: taxActions.mapOverviewRowsToBolTaxTransactions,

    // Comment actions (add, remove)
    useAddCommentMutation: commentActions.useAddCommentMutation,
    useRemoveCommentMutation: commentActions.useRemoveCommentMutation,

    // Utility functions (use from status actions as the primary source)
    invalidateMatchQueries: statusActions.invalidateMatchQueries,

    // High-level handlers for backward compatibility
    ...matchActionHandlers,
  }
}
